import React, { useRef, useLayoutEffect } from 'react';
import { displayElementAroundAnchor } from 'utilities/element-position';

function refresh() {
  window.location.reload();
}

function LoadingPopover(props) {
  const panel = useRef(null);
  useLayoutEffect(function place() {
    displayElementAroundAnchor(panel.current, props.anchor.current, document.body, 5, 5, 'bottom', false);
  }, [props.anchor]);
  if (props.failed === true) {
    return <div className="editor-link-popover" ref={panel} contentEditable={false}>
      <p>These settings could not be loaded.</p>
      <button type="button" className="application-button" onClick={refresh}>Refresh the page</button>
    </div>;
  }
  return <div className="editor-link-popover" ref={panel} contentEditable={false}><ht-spinner size="small" /></div>;
}

export default LoadingPopover;
